var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavigateNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.4616 7.00011L4.03377 2.57228C3.84566 2.38417 3.84566 2.07919 4.03377 1.89109C4.22187 1.70298 4.52685 1.70298 4.71495 1.89109L9.47729 6.65342C9.47935 6.65541 9.4814 6.65742 9.48343 6.65946C9.67154 6.84756 9.67154 7.15254 9.48343 7.34065L4.71511 12.109C4.52701 12.2971 4.22203 12.2971 4.03392 12.109C3.84582 11.9209 3.84582 11.6159 4.03392 11.4278L8.4616 7.00011Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigateNext);
export default __webpack_public_path__ + "static/media/navigateNext.0e87f87b66619895b00279a0de759c52.svg";
export { ForwardRef as ReactComponent };